import React from "react";
import { Link } from "react-router-dom";
export default class Booking extends React.Component 
{
    render()
     {
        return<>
             <div>
           <div className="container-fluid bg-danger kpy-5 mb-5">
        <div className="container py-5">
            <div className="row align-items-center py-4">
                <div className="col-md-6 text-center text-md-left">
                    <h1 className="display-4 mb-4 mb-md-0 text-secondary text-uppercase"> Booking</h1>
                </div>
             </div>
         </div>
      </div>
    </div>

        <div className="form-container">
        <h2 className="form-heading">Book Your Services</h2>
        <form action="#" method="POST">
          <div className="form-group">
            <label for="fullname" className="form-label">Full Name</label>
            <input type="text" id="fullname" name="fullname" className="form-input" placeholder="Enter your full name" required/>
          </div>
          <div className="form-group">
            <label for="email" className="form-label">Email Address</label>
            <input type="email" id="email" name="email" className="form-input" placeholder="Enter your email address" required/>
          </div>
          <div className="form-group">
            <label for="email" className="form-label">Client Address</label>
            <input type="text" id="email" name="email" className="form-input" placeholder="Enter your email address" required/>
          </div>
          <div className="form-group">
            <label for="check-in-date" className="form-label">Check-in Date</label>
            <input type="date" id="check-in-date" name="check-in-date" className="form-input" required/>
          </div>
          <div className="form-group">
            <label for="check-out-date" className="form-label">Check-out Date</label>
            <input type="date" id="check-out-date" name="check-out-date" className="form-input" required/>
          </div>
          <div className="form-group">
            <label for="room-type" className="form-label">Service Type</label>
            <select id="room-type" name="room-type" className="form-input" required>
              <option value="" disabled selected>Select a service type</option>
              <option value="Cleaning">Cleaning</option>
              <option value="Carpenter">Carpenter</option>
              <option value="Plumbing">Plumbing</option>
              <option value="Electrician">Electrician</option>
            </select>
          </div>
          <div className="form-group">
            <label for="room-type" className="form-label">Required ServiceMan</label>
            <select id="room-type" name="room-type" className="form-input" required>
              <option value="" disabled selected>Required ServiceMan</option>
              <option value="Required ServiceMan">2 ServiceMan</option>
              <option value="Required ServiceMan">4 ServiceMan</option>
              <option value="Required ServiceMan">6 ServiceMan</option>
              <option value="Required ServiceMan">8 ServiceMan</option>
            </select>
          </div>
          <div className="form-group">
            <label for="message" className="form-label">Message (optional)</label>
            <textarea id="message" name="message" className="form-input" placeholder="Enter any additional message"></textarea>
          </div>
          <div className="form-group">
            <button type="submit" className="form-submit">Book Now</button>
          </div>
        </form>
      </div>
    </>

     }
}